module.exports = __webpack_public_path__ + "img/IR.07b0e52d.svg";